import { foundationCardStyles } from '@genesislcap/foundation-ui';
import { neutralForegroundRest } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const zeroCardStyles = (context, definition) => css `
  ${foundationCardStyles(context, definition)}
  :host {
    background-color: var(--zero-card-fill-color, var(--neutral-layer-2));
    color: ${neutralForegroundRest};
  }
`;
